import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ZeitUnterartsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ZeitUnterartsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ZeitUnterartsServiceModule {}
